import React, {useState} from "react";
import NavBar from "../shared/components/Navbar";
import Footer from "../shared/components/Footer";
import FAQSection from "./components/FAQSection";
import PricingCard from "./components/PricingCard";
import TestimonialsSection from './components/TestimonialsSection'
import {plans} from '../../assets/data/planData'


const PricingPage = () => {
  const [hovered, setHovered] = useState(null);
  return(
    <div className="min-h-screen flex flex-col bg-gray-50">
    <NavBar />
    <main className="flex-1 max-w-7xl mx-auto pt-28 pb-10 px-4">
      <h1 className="text-4xl font-bold mb-6 text-btn-primary text-center">Simple, Transparent Pricing</h1>
      <p className="text-lg text-btn-secondary-text mb-10 text-center max-w-2xl mx-auto">No hidden fees. Cancel anytime. Try all features free for 30 days—no credit card required!</p>
       <div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-8">
                {plans.map((plan) => {
                  const isHighlighted = hovered ? (plan.name === hovered) : plan.highlight;
      
                  return (
                    <div
                      key={plan.name}
                      className="w-full"
                      onMouseEnter={() => setHovered(plan.name)}
                      onMouseLeave={() => setHovered(null)}
                      onFocus={() => setHovered(plan.name)}
                      onBlur={() => setHovered(null)}
                      tabIndex={0}
                    >
                      <PricingCard plan={plan} highlight={isHighlighted} />
                    </div>
                  );
                })}
              </div>
      
       <TestimonialsSection/>
      <FAQSection />
    </main>
    <Footer />
  </div>
  )
}

export default PricingPage;
